/**
 * 获取URL地址中的参数值
 * @param
 * query: URL地址中？后的所有字符
 * param:
 * @returns {*}
 */
function filterUrlPamram(param, query = window.location.search) {
  let iLen = param.length; //获取你的参数名称长度
  let iStart = query.indexOf(param); //获取你该参数名称的其实索引
  if (iStart === -1)
  //-1为没有该参数
    return '';
  iStart += iLen + 1;
  let iEnd = query.indexOf('&', iStart); //获取第二个参数的其实索引
if (iEnd === -1)
//只有一个参数
  return query.substring(iStart); //获取单个参数的参数值
return query.substring(iStart, iEnd); //获取第二个参数的值
}

function getUrlBase64(url, callback) {
  var canvas = document.createElement("canvas");   //创建canvas DOM元素
  var ctx = canvas.getContext("2d");
  var img = new Image;
  img.crossOrigin = 'Anonymous';
  img.src = 'http://ovopark.oss-cn-hangzhou.aliyuncs.com/front/2019/10/24/HiY3EcdE2aGwywR.jpg';
  img.onload = function () {
    canvas.height = 540; //指定画板的高度,自定义
    canvas.width = 960; //指定画板的宽度，自定义
    try {
      ctx.drawImage(img, 0, 0, 960, 540); //参数可自定义
      var dataURL = canvas.toDataURL("image/" + ext);
      // console.log(dataURL);
      callback && callback.call(this, dataURL); //回掉函数获取Base64编码
      canvas = null;
    }catch (e) {
      callback && callback.call(this, e,false);
    }
  };
}
//数组中某个属性拼接字符串
function getListItemcombination(list=[], attr='id', delimiter=',') {
  const arr = list.reduce((pre, cur) => pre.concat(cur[attr]), []);
  return arr.join(delimiter)
}

//生成随机数
function randomString(len) {
  len = len || 32;
  var $chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var maxPos = $chars.length;
  var pwd = "";
  for (var i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}

//防抖
function debounce(fn, time) {
  let timeout = null;
  return function () {
    if(!timeout) clearTimeout(timeout)
    timeout = setTimeout(fn, time)
  }
}
export {
  filterUrlPamram,
  getUrlBase64,
  getListItemcombination,
  randomString,
  debounce
}